import ErrorController from './ErrorController';

export default {
  ErrorController: () => {
    return Promise.resolve({ default: ErrorController });
  },
  DisclaimerController: () => import('./DisclaimerController'),
  StartController: () => import('./StartController'),
  AssessmentController: () => import('./AssessmentController'),
  FinishController: () => import('./FinishController'),
};

// export default {
//   ERROR: (cb) => {
//     cb(ErrorController);
//   },
//   DISCLAIMER: (cb) => {
//     require.ensure(
//       ['./DisclaimerController'],
//       (require) => {
//         const Controller = require('./DisclaimerController').default;
//         cb(Controller);
//       },
//     );
//   },
//   START: (cb) => {
//     require.ensure(
//       ['./StartController'],
//       (require) => {
//         const Controller = require('./StartController').default;
//         cb(Controller);
//       },
//     );
//   },
//   ASSESSMENT: (cb) => {
//     require.ensure(
//       ['./AssessmentController'],
//       (require) => {
//         const Controller = require('./AssessmentController').default;
//         cb(Controller);
//       },
//     );
//   },
//   FINISH: (cb) => {
//     require.ensure(
//       ['./FinishController'],
//       (require) => {
//         const Controller = require('./FinishController').default;
//         cb(Controller);
//       },
//     );
//   },
// };



// WEBPACK FOOTER //
// ./src/controllers/index.js